"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinesweeperVersusPaths = void 0;
exports.MinesweeperVersusPaths = {
    home: "/",
    singleplayerRanked: "/singleplayer/ranked",
    singleplayerOffline: "/singleplayer/offline",
};
